<template>
  <div :key="componentKey">
    <div class="contenant" v-if="situation && situation.media">
      <input v-if="!showPlayButton" type="range" v-model="width" min="0" max="100" value="50" />

      <div class="video">
        <video id="video" preload="auto">
          <source id="image" class="img" :src="situation.media.filename" type="video/mp4" />
        </video>
      </div>

      <figure v-if="showPlayButton">
        <button name="play" v-on:click="playVideo"></button>
      </figure>

      <div id="filtre" v-bind:style="{ width: width + '%' }"></div>

      <div class="glass"></div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      width: 50,
      showPlayButton: true,
      componentKey: 0,
    };
  },
  mounted() {
    const video = document.querySelector('#video');
    // const glassMask = document.querySelector(".glass");
    if (video) {
      video.onended = () => {
        this.hideCursor();
      };

      // const myObserver = new ResizeObserver(entries => {
      //   entries.forEach(entry => {
      //     glassMask.style.width = `${entry.contentRect.width - 120 * 2}px`;
      //     glassMask.style.height = `${entry.contentRect.height - 90 * 2}px`;
      //   });
      // });

      // myObserver.observe(video);

      onWindowResize();

      window.addEventListener('resize', onWindowResize, false);
    }
  },
  destroyed() {
    window.removeEventListener('resize', onWindowResize, false);
  },
  computed: {
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
  },
  methods: {
    playVideo: function() {
      const videos = document.querySelectorAll('video');
      if (videos) {
        videos.forEach(video => {
          video.play();
        });
      }
      this.showPlayButton = false;
    },
    hideCursor: function() {
      this.showPlayButton = true;
    },
    forceRerender() {
      this.componentKey += 1;
      setTimeout(() => {
        onWindowResize();
      });
    },
  },
  watch: {
    '$route.params.idSituation': function() {
      //Force re render component
      this.forceRerender();
    },
  },
};

const ratioGlassesMask = 16 / 9;
var leftMargin = 120;
var topMargin = 90;

function computeSize() {
  let isFullScreen = window.innerHeight === screen.height;
  let width = isFullScreen ? screen.width : window.innerWidth - leftMargin * 2;
  let height = isFullScreen ? screen.height : width / ratioGlassesMask;
  if (!isFullScreen) {
    const maxHeight = window.innerHeight - topMargin * 2;
    if (height > maxHeight) {
      height = maxHeight;
      width = height * ratioGlassesMask;
    }
  }
  return { width, height };
}

function onWindowResize() {
  const size = computeSize();

  const video = document.querySelector('#video');
  const glassMask = document.querySelector('.glass');
  video.style.width = size.width + 'px';
  video.style.height = size.height + 'px';
  glassMask.style.width = size.width + 'px';
  glassMask.style.height = size.height + 'px';
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenant {
  position: relative;
  width: fit-content;
  margin: auto;
  overflow: hidden;
}

.glass {
  -webkit-mask-image: url(/glass.svg);
  mask-image: url(/glass.svg);
  -webkit-mask-size: auto 100%;
  mask-size: auto 100%;
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  z-index: 2;
  opacity: 0.85;
  background-color: white;
}

#filtre {
  height: 100%;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  opacity: 0.4;
  z-index: 2;
}

video {
  height: 87vh;
  display: block;
  margin: auto;
  object-fit: cover;
}
video:before {
  content: '';
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #000000;
  opacity: 0.7;
}
.img {
  position: relative;
}

input[type='range'] {
  width: 100%;
  height: 100%;
  /* -webkit-appearance: none; */
  opacity: 0;
  left: 0;
  position: absolute;
  z-index: 3;
  background-color: transparent;
}
input[type='range']::-ms-tooltip {
  display: none;
}
input:focus {
  outline-width: 0;
}

input[type='range']::-webkit-slider-thumb {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  border: 2px #5ebeb3 solid;
  background: transparent;
  cursor: pointer;
  -webkit-appearance: none;
}

figure {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -100px;
  overflow: hidden;
  position: absolute;
  z-index: 100;
  transition: all 0.2s ease-in-out;
}
figure:hover {
  transform: scale(1.1);
}
figure button[name='play'] {
  width: 200px;
  height: 200px;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 100%;
  margin: auto;
  cursor: pointer;
}
figure button[name='play']:focus {
  outline: 0;
  border: none;
  box-shadow: none;
}

figure button[name='play']::after {
  content: '';
  display: inline-block;
  position: relative;

  top: 1px;
  left: 3px;
  border-style: solid;
  border-width: 50px 0 50px 60px;
  border-color: transparent transparent transparent white;
}
/* 
@media screen and (max-width: 1440px) {
  video {
    max-width: 1200px;
  }
}

@media screen and (max-width: 1280px) {
  video {
    height: 64vh;
  }
} */
</style>
